import script from "./AppFloatingMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AppFloatingMenu.vue?vue&type=script&setup=true&lang=js"

import "./AppFloatingMenu.vue?vue&type=style&index=0&id=8783c7e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8783c7e4"]])

export default __exports__